import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";

import { cn } from "utils";
import { buildLogoDevUrl } from "utils/buildLogoDevUrl";

const sizeClasses = {
  xs: "h-7 w-7",
  sm: "h-10 w-10",
  md: "h-12 w-12 md:h-16 md:w-16",
  lg: "h-16 w-16 md:h-20 md:w-20",
};

const getInitial = (name, fallBackInitial) =>
  name?.trim()?.charAt(0)?.toUpperCase() || fallBackInitial;

const LogoAvatar = ({
  name,
  domain,
  size,
  fallBackInitial,
  placeHolder,
  className,
}) => {
  const [imgError, setImgError] = useState(false);
  const initial = getInitial(name, fallBackInitial);
  const src = useMemo(
    () =>
      domain
        ? buildLogoDevUrl(
            domain,
            name,
            "webp",
            "light",
            undefined,
            undefined,
            undefined,
            "404"
          )
        : "",
    [domain, name]
  );

  if (src && !imgError) {
    return (
      <img
        className={cn(
          "inline-block shrink-0 overflow-hidden rounded-md bg-white object-contain",
          sizeClasses[size],
          className
        )}
        alt={name || ""}
        src={src}
        onError={() => setImgError(true)}
      />
    );
  }

  if (placeHolder) {
    return <>{placeHolder}</>;
  }

  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center rounded-md bg-blue-100 text-sm font-semibold text-blue-700",
        sizeClasses[size],
        className
      )}
      aria-label={name || "Company"}
    >
      {initial}
    </div>
  );
};

LogoAvatar.propTypes = {
  name: PropTypes.string,
  domain: PropTypes.string,
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  fallBackInitial: PropTypes.string,
  placeHolder: PropTypes.node,
  className: PropTypes.string,
};

LogoAvatar.defaultProps = {
  name: "",
  domain: "",
  size: "md",
  fallBackInitial: "C",
  placeHolder: null,
  className: "",
};

export default LogoAvatar;
